export default __webpack_public_path__ + "static/logo-light-f1008bfe9eb8bf63c25815b4f6a5ba07.svg";